<!--
 * @Author: ZhaoG
 * @Date: 2025-04-23 15:52:22
 * @LastEditors: ZhaoG
 * @LastEditTime: 2025-06-12 10:27:44
 * @FilePath: \gcp-fe\src\app\shop\components\zoneEntrance.vue
 * @Description: 专区入口 banner 轮播组件
-->

<template>
  <div class="carousel-container">
    <div class="carousel-title">{{ $t("zoneEntrance.title") }}</div>
    <div class="swiper-container">
      <swiper :options="swiperOptions" ref="mySwiper">
        <!-- 第一页和第二页各显示4张图片 -->
        <swiper-slide v-for="(page, pageIndex) in pages" :key="pageIndex">
          <div class="image-grid">
            <div
              v-for="(image, imageIndex) in page"
              :key="imageIndex"
              class="image-item"
            >
              <div class="image-wrapper">
                <img :src="image.imgUrl" :alt="image.title" />
              </div>
              <div class="slider-text">
                <h3>{{ image.title }}</h3>
                <p :class="`info${imageIndex}`">{{ image.description }}</p>
                <button @click="handleOp(image)">
                  {{ $t("zoneEntrance.imgData.btnText") }} >
                </button>
              </div>
            </div>
          </div>
        </swiper-slide>
      </swiper>

      <!-- 自定义分页器 -->
      <div class="swiper-pagination custom-pagination">
        <span
          v-for="(page, index) in pages"
          :key="index"
          :class="['pagination-bullet', { active: currentPage === index }]"
          @click="goToPage(index)"
        >
        </span>
      </div>

      <!-- 自定义导航按钮 -->
      <div
        class="swiper-button-prev"
        :class="{ 'swiper-button-disabled': currentPage === 0 }"
        @click="prevPage"
      >
        <span class="nav-arrow">&#10094;</span>
      </div>
      <div
        class="swiper-button-next"
        :class="{ 'swiper-button-disabled': currentPage === pages.length - 1 }"
        @click="nextPage"
      >
        <span class="nav-arrow">&#10095;</span>
      </div>
    </div>
  </div>
</template>

<script>
// import { updateHits } from "@/app/shop/api/shopping";
// import { updateAdvHits } from "../api/shopping";
export default {
  name: "slideShow",
  // props: {
  //   imgData: {
  //     type: Array,
  //     default: () => []
  //   }
  // },
  data() {
    return {
      // swiper配置
      swiperOptions: {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: false,
        allowTouchMove: false, // 禁用触摸滑动，只通过按钮控制
        on: {
          slideChange: () => {
            this.currentPage = this.$refs.mySwiper.swiper.activeIndex;
          }
        }
      },

      currentPage: 0,

      imgData: [
        {
          imgUrl: require("@/basa/assets/images/zq5.png"),
          linkUrl: "https://hwsp.iccec.cn/",
          title: this.$t("zoneEntrance.imgData.label"),
          description: this.$t("zoneEntrance.imgData.descriptionOne"),
          key: "3.1"
        },
        {
          imgUrl: require("@/basa/assets/images/zq6.png"),
          linkUrl: "",
          title: this.$t("zoneEntrance.imgData.RH"),
          description: this.$t("zoneEntrance.imgData.descriptionTwo"),
          key: "3.2"
        },
        {
          imgUrl: require("@/basa/assets/images/zq1.png"),
          linkUrl: this.$addUrlPerFix(process.env.VUE_APP_ZY_URL),
          title: this.$t("zoneEntrance.imgData.resource"),
          description: this.$t("zoneEntrance.imgData.descriptionThree"),
          key: "3.3"
        },
        {
          imgUrl: require("@/basa/assets/images/zq2.png"),
          linkUrl: this.$addUrlPerFix(process.env.VUE_APP_WLY_URL),
          title: this.$t("zoneEntrance.imgData.logistics"),
          description: this.$t("zoneEntrance.imgData.descriptionFour"),
          key: "3.4"
        },
        // {
        //   imgUrl: require("@/basa/assets/images/zq3.png"),
        //   linkUrl: this.$addUrlPerFix(process.env.VUE_APP_LIANCAI_URL),
        //   title: "联合采购专区",
        //   description: "联合采购，让采购更高效",
        //   key: "3.5"
        // },
        {
          imgUrl: require("@/basa/assets/images/zq4.png"),
          linkUrl: this.$addUrlPerFix(process.env.VUE_APP_YC_URL),
          title: this.$t("zoneEntrance.imgData.warehouse"),
          description: this.$t("zoneEntrance.imgData.descriptionFive"),
          key: "3.6"
        },
        {
          imgUrl: require("@/basa/assets/images/zq7.png"),
          linkUrl: this.$addUrlPerFix(process.env.VUE_APP_EAPP_URL),
          title: this.$t("zoneEntrance.imgData.machine"),
          description: this.$t("zoneEntrance.imgData.descriptionSix"),
          key: "3.7"
        },
        {
          imgUrl: require("@/basa/assets/images/zq8.png"),
          linkUrl: this.$addUrlPerFix(process.env.VUE_APP_CLZL_URL),
          title: this.$t("zoneEntrance.imgData.verchicle"),
          description: this.$t("zoneEntrance.imgData.descriptionSeven"),
          key: "3.8"
        }
        // {
        //   imgUrl: require("@/basa/assets/images/zq9.png"),
        //   linkUrl: this.$addUrlPerFix(process.env.VUE_APP_JR_URL),
        //   title: "供应链金融",
        //   description: "中交集团供应链专属， 纯线上",
        //   key: "3.9"
        // }
      ],
      srhStatus: 0
    };
  },
  mounted() {
    this.srhStatus = Number(sessionStorage.getItem("rhStatus")) || 0;
  },
  computed: {
    // 添加新的计算属性来过滤数据
    filteredImgData() {
      if (this.srhStatus === 0) {
        // 当 srhStatus 为 0 时，过滤掉 RH 专区
        return this.imgData.filter(item => item.title !== "RH专区");
      }
      // 当 srhStatus 为 1 时，返回所有数据
      return this.imgData;
    },

    // 修改原有的 pages 计算属性，使用过滤后的数据
    pages() {
      const result = [];
      const data = this.filteredImgData;

      // 根据过滤后的数据长度动态计算每页显示的数量
      const itemsPerPage = 4;
      const totalPages = Math.ceil(data.length / itemsPerPage);

      for (let i = 0; i < totalPages; i++) {
        result.push(data.slice(i * itemsPerPage, (i + 1) * itemsPerPage));
      }

      return result;
    },
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  methods: {
    // 前往指定页面
    goToPage(index) {
      this.swiper.slideTo(index);
    },
    // 上一页
    prevPage() {
      if (this.currentPage > 0) {
        this.swiper.slideTo(this.currentPage - 1);
      }
    },
    // 下一页
    nextPage() {
      if (this.currentPage < this.pages.length - 1) {
        this.swiper.slideTo(this.currentPage + 1);
      }
    },
    handleOp(item) {
      switch (item.key) {
        case "3.1":
          // 海外专区 hwsp
          window.location.href = "https://hwsp.iccec.cn/";

          break;
        case "3.2":
          // RH专区
          this.$message({
            message: "域名申请中",
            type: "error",
            duration: 3000,
            showClose: true,
            ccuiCustom: true
          });
          break;
        case "3.3":
          // 资源共享
          // window.location.href = "https://yz.iccec.cn/direct-rent/list";
          window.location.href = `${this.$addUrlPerFix(
            process.env.VUE_APP_YZ_URL
          )}/direct-rent/list`;

          break;
        case "3.4": {
          // 物流专区
          let url = this.$addUrlPerFix(process.env.VUE_APP_WLY_URL);
          if (url.includes("test01")) {
            return false;
          } else {
            window.location.href = url;
          }
          break;
        }
        case "3.5": {
          // 联合采购专区
          let url = this.$addUrlPerFix(process.env.VUE_APP_LIANCAI_URL);
          if (url.includes("test01")) {
            return false;
          } else {
            window.location.href = url;
          }
          break;
        }
        case "3.6":
          // 智慧云仓：https://yc.iccec.cn/
          window.location.href = `${this.$addUrlPerFix(
            process.env.VUE_APP_YC_URL
          )}`;

          break;
        case "3.7": {
          // 机电与零配件：https://eapp.iccec.cn
          let url = this.$addUrlPerFix(process.env.VUE_APP_EAPP_URL);
          if (url.includes("test01")) {
            return false;
          } else {
            window.location.href = url;
          }
          break;
        }
        case "3.8":
          // 车辆专区：https://clzl.iccec.cn/
          window.location.href = `${this.$addUrlPerFix(
            process.env.VUE_APP_CLZL_URL
          )}`;

          break;
        case "3.9":
          // 供应链金融：https://jr.iccec.cn/
          window.location.href = `${this.$addUrlPerFix(
            process.env.VUE_APP_JR_URL
          )}`;

          break;

        default:
          break;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.carousel-container {
  max-width: 1180px;
  margin: 0 auto;
  position: relative;
  padding: 20px 0;
  height: 240px;
}

.carousel-title {
  text-align: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 24px;
  color: #181818;
  padding-top: 18px;
  margin-bottom: 20px;
}

.swiper-container {
  position: relative;
  padding: 0 20px;
}

.image-grid {
  display: flex;
  flex-wrap: wrap;
  // justify-content: center;
  justify-content: flex-start;
  gap: 20px;
}

.image-item {
  width: calc(25% - 15px);
  text-align: center;
  position: relative;
}

/* 最后一页只有一张图片，让它居中且宽度适中 */
.swiper-slide:last-child .image-item {
  // width: 50%;
  // margin: 0 auto;
  text-align: left;
}

.image-wrapper {
  overflow: hidden;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 10px;
}

img {
  width: 100%;
  height: auto;
  display: block;
  transition: transform 0.3s;
}

.image-item:hover img {
  transform: scale(1.05);
}

.slider-text {
  position: absolute;
  top: 0;
  // left: 9px;
  // background: rgba(0, 0, 0, 0.2);
  color: white;
  // padding: 10px;
  text-align: left;
  width: 260px;
  height: 180px;
  // border-radius: 5px;

  h3 {
    margin: 0;
    font-size: 18px;
    padding: 20px 0 0 20px;
  }

  p {
    margin: 10px 0;
    font-size: 14px;
    padding: 10px 20px;
  }

  // .info2 {
  //   width: 126px;
  // }

  // .info3 {
  //   width: 154px;
  // }

  button {
    margin-left: 20px;
    background: transparent;
    border: 1px solid white;
    color: white;
    padding: 5px 10px;
    cursor: pointer;
    position: absolute;
    bottom: 20px;
  }
}

/* 自定义分页器 */
.custom-pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.pagination-bullet {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #ccc;
  margin: 0 5px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.pagination-bullet.active {
  background-color: #3498db;
}

/* 自定义导航按钮 */
.swiper-button-prev,
.swiper-button-next {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 60px;
  background: #ebebeb;

  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

/deep/ .swiper-pagination {
  position: relative;
}

.swiper-button-prev {
  left: 0;
}

.swiper-button-next {
  right: 0;
}

.nav-arrow {
  font-size: 18px;
  font-weight: bold;
}

.swiper-button-disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .image-item {
    width: calc(50% - 10px);
  }

  .swiper-slide:last-child .image-item {
    width: 80%;
  }
}

@media (max-width: 480px) {
  .image-item {
    width: 100%;
  }

  .swiper-slide:last-child .image-item {
    width: 100%;
  }
}
</style>
